import Vue from 'vue'
import Router from 'vue-router'
import Videopage from '@/view/video'
import Index from '@/view/index'
import TipsPage from '@/view/tipsPage'
import RankingList from '@/view/rankingList'
import RewardRules from '@/view/rewardRules'
import registerAgreement from '@/view/registerAgreement'




import { is_weixin } from '../assets/utils/common'

Vue.use(Router)

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index,
            meta: {
                title: "传播爱，获大奖，请送我小心心",
            }
        },
        {
            path: '/tipsPage',
            name: 'tipsPage',
            component: TipsPage,
            meta: {
                title: "传播爱，获大奖，请送我小心心",
            }
        },
        {
            path: '/rankingList',
            name: 'rankingList',
            component: RankingList,
            meta: {
                title: "PK赛排行榜",
            }
        },
        {
            path: '/registerAgreement',
            name: 'registerAgreement',
            component: registerAgreement,
            meta: {
                title: "注册协议",
            }
        },
        {
            path: '/rewardRules',
            name: 'rewardRules',
            component: RewardRules,
            meta: {
                title: "奖励规则",
            }
        },


        //活动结束
        // {
        //   path: '/activityEnd',
        //   name: 'activityEnd',
        //   component: activityEnd,
        //   meta: {
        //       title: "活动结束",
        //   }
        // },

        // 这个页面时提供给微信团队排查问题的，放在最后
        {
            path: '/videopage',
            name: 'videopage',
            component: Videopage
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name !== "tipsPage") {
        console.log(is_weixin())
        if (is_weixin()) {
            next()
        } else {
            next({
                path: '/tipsPage'
            })
        }
    } else {
        next()
    }
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js